import Axios from 'axios';
import Qs from 'qs';

export default {

  // 报修项目分页列表
  listPage(
    repair_item_name,
    repair_item_type,
    community_id,
    page,
    per_page
  ) {
    return Axios.get('/wybx/api/admin/repair_item', {
      params: {
        repair_item_name,
        repair_item_type,
        community_id,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 报修项目列表
  list(
    community_id
  ) {
    return Axios.get('/wybx/api/admin/repair_items', {
      params: {
        community_id
      }
    });
  },

  // 报修项目类型
  type() {
    return Axios.get('/wybx/api/admin/repair_types');
  },

  // 报修项目上线
  online(
    id
  ) {
    return Axios.post(`/wybx/api/admin/repair_item/online/${id}`);
  },

  // 报修项目下线
  offline(
    id
  ) {
    return Axios.post(`/wybx/api/admin/repair_item/offline/${id}`);
  },

  // 报修项目新增
  add(
    repair_item_name,
    repair_item_type,
    community_ids
  ) {
    return Axios.post('/wybx/api/admin/repair_item', {
      repair_item_name,
      repair_item_type,
      community_ids
    });
  },

  // 报修项目编辑
  edit(
    id,
    repair_item_name,
    repair_item_type,
    community_ids
  ) {
    return Axios.put(`/wybx/api/admin/repair_item/${id}`, {
      repair_item_name,
      repair_item_type,
      community_ids
    });
  },

  // 报修项目详情
  info(
    id
  ) {
    return Axios.get(`/wybx/api/admin/repair_item/${id}`);
  }

}